import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "@reach/router";
import { AppContext } from "~/scripts/context/app";
import Captions from "~/scripts/components/Captions";

class VideoGalleryItem extends Component {
    static propTypes = {
        film: PropTypes.object,
        index: PropTypes.number,
        isCurrent: PropTypes.bool,
        onClick: PropTypes.func
    };

    static contextType = AppContext;

    handleClick = e => {
        const { index, onClick } = this.props;

        if (onClick) {
            onClick(e, index);
        }
    };

    renderPoster = (film, isVideo) => {
        const isVideoOrImage = isVideo ? "is-video" : "is-image";

        return (
            film.poster && (
                <picture className="video-gallery-item__image">
                    <source
                        media="(max-width: 900px)"
                        srcSet={film.poster.mobile}
                    />
                    <img
                        className={isVideoOrImage}
                        src={film.poster.desktop}
                        alt={`${film.line1} - ${film.line2}`}
                    />
                </picture>
            )
        );
    };

    renderLink = (entryType, directorSlug, film, theme) => {
        return (
            <Link
                to={`/videos/${entryType}/${directorSlug}/${film.id}`}
                className={classNames(
                    "video-gallery-item__poster",
                    `theme-${theme}`
                )}
                onClick={this.handleClick}
                state={{ theme }}
            >
                {this.renderPoster(film)}
            </Link>
        );
    };

    renderExternalLink = (entryType, directorSlug, film, theme) => {
        return (
            <a
                onClick={this.handleClick}
                href={`${film.externalLink}`}
                target="_blank"
                className={classNames(
                    "video-gallery-item__poster",
                    `theme-${theme}`
                )}
                state={{ theme }}
            >
                {this.renderPoster(film)}
            </a>
        );
    };

    render() {
        const { isCurrent, film, directorSlug, entryType } = this.props;
        const { theme } = this.context;

        const isVideo = film && film.url && film.url.includes("vimeo");

        const mediaEl = isVideo
            ? this.renderLink(entryType, directorSlug, film, theme)
            : this.renderExternalLink(entryType, directorSlug, film, theme);

        return (
            <div
                className={classNames("video-gallery-item", {
                    "is-current": isCurrent
                })}
            >
                {mediaEl}

                <div
                    className={classNames(
                        "video-gallery-item__caption",
                        `theme-${theme}`
                    )}
                >
                    <Captions line1={film.line1} line2={film.line2} />
                </div>
            </div>
        );
    }
}

export default VideoGalleryItem;



// WEBPACK FOOTER //
// ./src/scripts/components/VideoGalleryItem.js